export const GET_RD_PIN_FILE = 'GET_RD_PIN_FILE'
export const GET_TRANSACTION_TRACKER = 'GET_TRANSACTION_TRACKER'
export const POST_HW_LOG = 'POST_HW_LOG'
export const GET_HW_LOG_OPTIONS = 'GET_HW_LOG_OPTIONS'
export const CLEAR_MESSAGE = 'CLEAR_MESSAGE'
export const GET_HARDWARE_INVENTORY = 'GET_HARDWARE_INVENTORY'
export const UPLOAD_INVENTORY_FILE = 'UPLOAD_INVENTORY_FILE'
